var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"IcomoonIcon",class:'Icon' + _vm.name},_vm._l((_vm.layersCount),function(index){return _c('span',{key:index,staticClass:"IcomoonIcon-path",class:'path' + index})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }